export const formatShortDate = (originalDate: string) => {
    if (!originalDate) return '';
    const splited = originalDate.split('T');
    const date = new Date(splited[0]).toLocaleDateString('pt-BR');
    return `${date}`;
};
